import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-right-up', 'CornerRightUp', [["path",{"d":"M13.973 5v10a4 4 0 0 1-4 4H5m8.973-14L8.946 9.78M13.973 5 19 9.78","key":"svg-0"}]]);